// import React from "react";
// import {
//   Box,
//   Container,
//   Grid,
//   Typography,
//   Link,
//   IconButton,
//   Stack,
//   Divider,
//   useTheme,
//   alpha
// } from "@mui/material";
// import {
//   Facebook as FacebookIcon,
//   Twitter as TwitterIcon,
//   Instagram as InstagramIcon,
//   LinkedIn as LinkedInIcon,
//   Phone as PhoneIcon,
//   Email as EmailIcon,
//   LocationOn as LocationIcon
// } from "@mui/icons-material";

// const Footer = () => {
//   const theme = useTheme();

//   const footerSections = [
//     {
//       title: "Company",
//       links: [
//         { name: "About Us", href: "/about" },
//         { name: "Our Team", href: "/team" },
//         { name: "Careers", href: "/careers" },
//         { name: "Press Kit", href: "/press" },
//         { name: "Blog", href: "/blog" }
//       ]
//     },
//     {
//       title: "Services",
//       links: [
//         { name: "Airbnb Cleaning", href: "/services/airbnb" },
//         { name: "Vacation Rental", href: "/services/vacation-rental" },
//         { name: "Deep Cleaning", href: "/services/deep-cleaning" },
//         { name: "Move In/Out", href: "/services/move-cleaning" },
//         { name: "Commercial", href: "/services/commercial" }
//       ]
//     },
//     {
//       title: "For Cleaners",
//       links: [
//         { name: "Become a Cleaner", href: "/become-a-cleaner" },
//         { name: "Cleaner App", href: "/cleaner-app" },
//         { name: "Training", href: "/training" },
//         { name: "Support", href: "/cleaner-support" },
//         { name: "Earnings", href: "/earnings" }
//       ]
//     },
//     {
//       title: "Support",
//       links: [
//         { name: "Help Center", href: "/help" },
//         { name: "Contact Us", href: "/contact" },
//         { name: "FAQs", href: "/faqs" },
//         { name: "Service Areas", href: "/service-areas" },
//         { name: "Booking Help", href: "/booking-help" }
//       ]
//     },
//     {
//       title: "Legal",
//       links: [
//         { name: "Privacy Policy", href: "/privacyp" },
//         { name: "Terms of Service", href: "/terms" },
//         { name: "Cookie Policy", href: "/cookies" },
//         { name: "Insurance", href: "/insurance" },
//         { name: "Compliance", href: "/compliance" }
//       ]
//     }
//   ];

//   const contactInfo = [
//     { icon: <PhoneIcon sx={{ fontSize: 18 }} />, text: "+1 (555) 123-4567" },
//     { icon: <EmailIcon sx={{ fontSize: 18 }} />, text: "hello@freshsweeper.com" },
//     { icon: <LocationIcon sx={{ fontSize: 18 }} />, text: "San Francisco, CA" }
//   ];

//   const socialLinks = [
//     { icon: <FacebookIcon />, href: "https://facebook.com", name: "Facebook" },
//     { icon: <TwitterIcon />, href: "https://twitter.com", name: "Twitter" },
//     { icon: <InstagramIcon />, href: "https://instagram.com", name: "Instagram" },
//     { icon: <LinkedInIcon />, href: "https://linkedin.com", name: "LinkedIn" }
//   ];

//   return (
//     <Box
//       component="footer"
//       sx={{
//         background: theme.palette.background.paper,
//         borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//         mt: 'auto'
//       }}
//     >
//       {/* Main Footer Content */}
//       <Container maxWidth="lg" sx={{ py: 6 }}>
//         <Grid container spacing={4}>
//           {/* Company Info Column */}
//           <Grid item xs={12} md={3}>
//             <Box sx={{ mb: 3 }}>
//               <Box
//                 sx={{
//                   width: 40,
//                   height: 40,
//                   borderRadius: "8px",
//                   background: theme.palette.primary.main,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: theme.palette.primary.contrastText,
//                   fontWeight: "bold",
//                   fontSize: "1.1rem",
//                   mb: 2
//                 }}
//               >
//                 FS
//               </Box>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   fontWeight: 700,
//                   color: theme.palette.text.primary,
//                   fontSize: "1.4rem",
//                   mb: 1
//                 }}
//               >
//                 FreshSweeper
//               </Typography>
//             </Box>
            
//             <Typography 
//               variant="body2" 
//               color={theme.palette.text.secondary}
//               sx={{ mb: 3, lineHeight: 1.6 }}
//             >
//               Professional cleaning services for Airbnb hosts and vacation rentals. 
//               Making every stay spotless and memorable.
//             </Typography>

//             {/* Contact Info */}
//             <Stack spacing={1} sx={{ mb: 3 }}>
//               {contactInfo.map((item, index) => (
//                 <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <Box sx={{ color: theme.palette.primary.main }}>
//                     {item.icon}
//                   </Box>
//                   <Typography variant="body2" color={theme.palette.text.secondary}>
//                     {item.text}
//                   </Typography>
//                 </Box>
//               ))}
//             </Stack>

//             {/* Social Links */}
//             <Box sx={{ display: "flex", gap: 1 }}>
//               {socialLinks.map((social, index) => (
//                 <IconButton
//                   key={index}
//                   component="a"
//                   href={social.href}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   sx={{
//                     color: theme.palette.text.secondary,
//                     background: alpha(theme.palette.primary.main, 0.05),
//                     '&:hover': {
//                       background: theme.palette.primary.main,
//                       color: theme.palette.primary.contrastText,
//                       transform: 'translateY(-2px)'
//                     },
//                     transition: 'all 0.3s ease'
//                   }}
//                 >
//                   {social.icon}
//                 </IconButton>
//               ))}
//             </Box>
//           </Grid>

//           {/* Menu Columns */}
//           {footerSections.map((section, index) => (
//             <Grid item xs={6} sm={4} md={2} key={index}>
//               <Typography 
//                 variant="h6" 
//                 sx={{ 
//                   fontWeight: 600, 
//                   color: theme.palette.text.primary,
//                   mb: 2,
//                   fontSize: '1rem'
//                 }}
//               >
//                 {section.title}
//               </Typography>
//               <Stack spacing={1}>
//                 {section.links.map((link, linkIndex) => (
//                   <Link
//                     key={linkIndex}
//                     href={link.href}
//                     variant="body2"
//                     sx={{
//                       color: theme.palette.text.secondary,
//                       textDecoration: 'none',
//                       '&:hover': {
//                         color: theme.palette.primary.main,
//                         textDecoration: 'underline'
//                       },
//                       transition: 'color 0.2s ease'
//                     }}
//                   >
//                     {link.name}
//                   </Link>
//                 ))}
//               </Stack>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>

//       {/* Bottom Bar */}
//       <Divider sx={{ borderColor: alpha(theme.palette.primary.main, 0.1) }} />
//       <Container maxWidth="lg" sx={{ py: 3 }}>
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: { xs: "column", sm: "row" },
//             justifyContent: "space-between",
//             alignItems: { xs: "flex-start", sm: "center" },
//             gap: 2
//           }}
//         >
//           <Typography 
//             variant="body2" 
//             color={theme.palette.text.secondary}
//             sx={{ textAlign: { xs: 'left', sm: 'center' } }}
//           >
//             © {new Date().getFullYear()} FreshSweeper Cleaning Service, Inc. All rights reserved.
//           </Typography>
          
//           <Box sx={{ display: "flex", gap: 3 }}>
//             <Link
//               href="/privacy"
//               variant="body2"
//               sx={{
//                 color: theme.palette.text.secondary,
//                 textDecoration: 'none',
//                 '&:hover': {
//                   color: theme.palette.primary.main,
//                   textDecoration: 'underline'
//                 }
//               }}
//             >
//               Privacy Policy
//             </Link>
//             <Link
//               href="/terms"
//               variant="body2"
//               sx={{
//                 color: theme.palette.text.secondary,
//                 textDecoration: 'none',
//                 '&:hover': {
//                   color: theme.palette.primary.main,
//                   textDecoration: 'underline'
//                 }
//               }}
//             >
//               Terms of Service
//             </Link>
//             <Link
//               href="/cookies"
//               variant="body2"
//               sx={{
//                 color: theme.palette.text.secondary,
//                 textDecoration: 'none',
//                 '&:hover': {
//                   color: theme.palette.primary.main,
//                   textDecoration: 'underline'
//                 }
//               }}
//             >
//               Cookie Policy
//             </Link>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default Footer;



import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Stack,
  Divider,
  useTheme,
  alpha
} from "@mui/material";
import {
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon
} from "@mui/icons-material";

const Footer = () => {
  const theme = useTheme();

  const footerSections = [
    {
      title: "Company",
      links: [
        { name: "About Us", href: "/about" },
        { name: "Our Team", href: "/team" },
        { name: "Careers", href: "/careers" },
        { name: "Press Kit", href: "/press" },
        
      ]
    },
    {
      title: "Services",
      links: [
        { name: "Bring Your Cleaner", href: "/services/bring-cleaner" },
        { name: "Find Cleaner", href: "/services/find-cleaner" },
        { name: "Automate Turnovers", href: "/services/automate-turnovers" },
        { name: "Manage Properties", href: "/services/manage-properties" },
        { name: "Cleaner Jobs", href: "/services/cleaner-jobs" }
      ]
    },


    {
      title: "For Cleaners",
      links: [
        { name: "Become a Cleaner", href: "/cleaner" },
        { name: "Cleaner App", href: "/cleaner-app" },
        { name: "Training", href: "/training" },
        { name: "Support", href: "/cleaner-support" },
        { name: "Earnings", href: "/earnings" }
      ]
    },
    {
      title: "Resources",
      links: [
        { name: "Help Center", href: "/help" },
        { name: "Contact Us", href: "/contact" },
        { name: "FAQs", href: "/faqs" },
        { name: "Host Guide", href: "/service-areas" },
        { name: "Blog", href: "/blog" }
      ]
    },
    
    {
      title: "Legal",
      links: [
        { name: "Privacy Policy", href: "/privacyp" },
        { name: "Terms of Service", href: "/terms" },
        { name: "Cookie Policy", href: "/cookies" },
        { name: "Insurance", href: "/insurance" },
        { name: "Compliance", href: "/compliance" }
      ]
    }
  ];

  const contactInfo = [
    { icon: <PhoneIcon sx={{ fontSize: 18 }} />, text: "+1 (555) 123-4567" },
    { icon: <EmailIcon sx={{ fontSize: 18 }} />, text: "hello@freshsweeper.com" },
    { icon: <LocationIcon sx={{ fontSize: 18 }} />, text: "San Francisco, CA" }
  ];

  const socialLinks = [
    { icon: <FacebookIcon />, href: "https://facebook.com", name: "Facebook" },
    { icon: <TwitterIcon />, href: "https://twitter.com", name: "Twitter" },
    { icon: <InstagramIcon />, href: "https://instagram.com", name: "Instagram" },
    { icon: <LinkedInIcon />, href: "https://linkedin.com", name: "LinkedIn" }
  ];

  return (
    <Box
      component="footer"
      sx={{
        background: theme.palette.background.paper,
        borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        mt: 'auto'
      }}
    >
      {/* Main Footer Content */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          {/* Company Info Column - Reduced width */}
          <Grid item xs={12} md={2} lg={2}>
            <Box sx={{ mb: 3 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "8px",
                  background: theme.palette.primary.main,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: theme.palette.primary.contrastText,
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  mb: 2
                }}
              >
                FS
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: theme.palette.text.primary,
                  fontSize: "1.2rem",
                  mb: 1
                }}
              >
                FreshSweeper
              </Typography>
            </Box>
            
            <Typography 
              variant="body2" 
              color={theme.palette.text.secondary}
              sx={{ mb: 3, lineHeight: 1.6, fontSize: '0.875rem' }}
            >
              Professional cleaning services for Airbnb hosts and vacation rentals.
            </Typography>

            {/* Contact Info */}
            <Stack spacing={1} sx={{ mb: 3 }}>
              {contactInfo.map((item, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ color: theme.palette.primary.main, minWidth: 20 }}>
                    {item.icon}
                  </Box>
                  <Typography variant="body2" color={theme.palette.text.secondary} sx={{ fontSize: '0.875rem' }}>
                    {item.text}
                  </Typography>
                </Box>
              ))}
            </Stack>

            {/* Social Links */}
            <Box sx={{ display: "flex", gap: 1 }}>
              {socialLinks.map((social, index) => (
                <IconButton
                  key={index}
                  component="a"
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: theme.palette.text.secondary,
                    background: alpha(theme.palette.primary.main, 0.05),
                    '&:hover': {
                      background: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      transform: 'translateY(-2px)'
                    },
                    transition: 'all 0.3s ease',
                    padding: '6px'
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Menu Columns - Equal width for all 5 sections */}
          {footerSections.map((section, index) => (
            <Grid item xs={6} sm={4} md={2} lg={2} key={index}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 600, 
                  color: theme.palette.text.primary,
                  mb: 2,
                  fontSize: '1rem'
                }}
              >
                {section.title}
              </Typography>
              <Stack spacing={1}>
                {section.links.map((link, linkIndex) => (
                  <Link
                    key={linkIndex}
                    href={link.href}
                    variant="body2"
                    sx={{
                      color: theme.palette.text.secondary,
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      '&:hover': {
                        color: theme.palette.primary.main,
                        textDecoration: 'underline'
                      },
                      transition: 'color 0.2s ease'
                    }}
                  >
                    {link.name}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Bottom Bar */}
      <Divider sx={{ borderColor: alpha(theme.palette.primary.main, 0.1) }} />
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2
          }}
        >
          <Typography 
            variant="body2" 
            color={theme.palette.text.secondary}
            sx={{ textAlign: { xs: 'left', sm: 'center' }, fontSize: '0.875rem' }}
          >
            © {new Date().getFullYear()} FreshSweeper Cleaning Service, Inc. All rights reserved.
          </Typography>
          
          <Box sx={{ display: "flex", gap: 3, flexWrap: 'wrap' }}>
            <Link
              href="/privacyp"
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': {
                  color: theme.palette.primary.main,
                  textDecoration: 'underline'
                }
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': {
                  color: theme.palette.primary.main,
                  textDecoration: 'underline'
                }
              }}
            >
              Terms of Service
            </Link>
            <Link
              href="/cookies"
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': {
                  color: theme.palette.primary.main,
                  textDecoration: 'underline'
                }
              }}
            >
              Cookie Policy
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;